import React, { useState } from 'react';
import { useTranslation } from 'hooks/useTranslation';
import { AuthPageLayout } from 'features/auth/components/AuthPageLayout';
import { useStyles } from './styles';
import LoginForm from 'features/auth/components/Login/LoginForm';
import LoginVerificationCode from 'features/auth/components/Login/VerificationCodeForm';
import { LoginInput } from 'features/auth/ts';
import useAuth from 'features/auth/hooks/useAuth';
import { addSuccessMessage } from 'features/message/redux/action';
import { useDispatch } from 'react-redux';

const Login = () => {
  const classes = useStyles();
  const [loginStep, setLoginStep] = useState<number>(1);
  const [loginInput, setLoginInput] = useState<LoginInput>();
  const { onLogin } = useAuth();
  const { t } = useTranslation('auth');
  const dispatch = useDispatch();

  const onInputCorrectEmailAndPassword = (data: LoginInput) => {
    setLoginStep(2);
    setLoginInput(data);
  };

  const onResendCode = () => {
    if (!loginInput) return;
    onLogin(loginInput.email, loginInput.password, () => {
      dispatch(addSuccessMessage(t('verificationCodeSuccessfullyResent', { ns: 'common' })));
    });
  };

  return (
    <AuthPageLayout
      title={loginStep === 1 ? t('logInToYourAccount') : t('verifyLoginCode')}
      additionalContentClassName={classes.loginFormWrapper}
    >
      {loginStep === 1 ? (
        <LoginForm onSuccessLogin={onInputCorrectEmailAndPassword} />
      ) : (
        <LoginVerificationCode onResendCode={onResendCode} />
      )}
    </AuthPageLayout>
  );
};

export default Login;
